/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRootMcpServersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListRootMcpServersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListRootMcpServersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListRootMcpServersSecurity$outboundSchema: z.ZodMiniType<
  ListRootMcpServersSecurity$Outbound,
  ListRootMcpServersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRootMcpServersSecurityToJSON(
  listRootMcpServersSecurity: ListRootMcpServersSecurity,
): string {
  return JSON.stringify(
    ListRootMcpServersSecurity$outboundSchema.parse(listRootMcpServersSecurity),
  );
}

/** @internal */
export type ListRootMcpServersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListRootMcpServersRequest$outboundSchema: z.ZodMiniType<
  ListRootMcpServersRequest$Outbound,
  ListRootMcpServersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listRootMcpServersRequestToJSON(
  listRootMcpServersRequest: ListRootMcpServersRequest,
): string {
  return JSON.stringify(
    ListRootMcpServersRequest$outboundSchema.parse(listRootMcpServersRequest),
  );
}
